export enum ISurveyRoundDurationTypes {
	ONE_WEEK = 'ONE_WEEK',
	TWO_WEEKS = 'TWO_WEEKS',
}
